import { FormlyFieldConfig } from '@ngx-formly/core';

// Mirrors LabelingRowComponent's own field-visibility rules so the modal's info
// panel always reflects the currently displayed row's actual data and the
// globally selected "Additional columns" — instead of a field list snapshotted
// once from the row that was clicked to open the modal.
function getFieldPriority(key: string): number {
  const k = key.toLowerCase();
  if (k === 'barcode') return 1;
  if (k === 'timestamp') return 2;
  if (k === 'class') return 3;
  if (k === 'photo') return 1000;
  return 100;
}

function getImageName(s3Path: string | undefined): string {
  if (!s3Path) return '';
  const path = s3Path.split(/[?#]/)[0];
  const imageName = path.substring(path.lastIndexOf('/') + 1);
  try {
    return decodeURIComponent(imageName);
  } catch {
    return imageName;
  }
}

export function buildModalInfoFields(item: any, selectedOptionalColumns: string[]): FormlyFieldConfig[] {
  const result: FormlyFieldConfig[] = [];
  const entries = Object.entries(item ?? {})
    .filter(([key]) => key !== 'id' && key !== 'ai_case' && !key.startsWith('_'))
    .sort(([a], [b]) => {
      const diff = getFieldPriority(a) - getFieldPriority(b);
      return diff !== 0 ? diff : a.localeCompare(b);
    });

  for (const [key, rawValue] of entries) {
    const value = rawValue as any;
    if (typeof value === 'string') {
      const k = key.toLowerCase();
      const alwaysVisible = k === 'barcode' || k === 'timestamp';
      if (!alwaysVisible && !selectedOptionalColumns.includes(key)) continue;
      result.push({
        key, className: 'flex-1', type: 'input',
        defaultValue: value,
        templateOptions: { label: key, required: false, disabled: true },
      });
    } else if (typeof value === 'boolean') {
      if (!selectedOptionalColumns.includes(key)) continue;
      result.push({
        key, className: 'flex-1', type: 'input',
        defaultValue: value ? 'Yes' : 'No',
        templateOptions: { label: key, required: false, disabled: true },
      });
    } else if (value && typeof value === 'object') {
      if (value.type === 'select') {
        result.push({
          key, className: 'flex-1', type: 'select',
          defaultValue: value.value ?? undefined,
          templateOptions: {
            label: value.templateOptions?.label ?? key,
            options: value.templateOptions?.options ?? [],
            required: value.templateOptions?.required ?? false,
          },
        });
      } else if (value.type === 'imageLink' && selectedOptionalColumns.includes('Image name')) {
        const imageName = getImageName(value.link);
        if (imageName) {
          result.push({
            key: `${key}Name`, className: 'flex-1', type: 'input',
            defaultValue: imageName,
            templateOptions: { label: 'Image name', required: false, disabled: true },
          });
        }
      }
    }
  }

  return result;
}
